import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Cecilia R.',
    location: 'Mendoza',
    quote: 'El primer mes ahorré más de $40.000 en comida sin que nadie se quejara de que comíamos peor.'
  }, {
    name: 'Sofía C.',
    location: 'La Plata',
    quote: 'Mis chicos ahora comen todo. El bono de recetas invisibles fue un antes y un después.'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén',
    quote: 'Cocino los domingos y el resto de la semana es piloto automático.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-267">
      <div className="text-center mb-12" data-id="element-268">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center gap-3 mb-4" data-id="element-269">
          <Heart className="w-8 h-8 text-red-400 fill-red-400" data-id="element-270" />
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-271">
            ❤️ MÁS FAMILIAS QUE YA LO TIENEN
          </h2>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-3 gap-6" data-id="element-272">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/40 border border-navy-700 p-8 rounded-2xl" data-id="element-273">
            <div className="flex gap-1 mb-4" data-id="element-274">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-275" />)}
            </div>
            <p className="text-lg text-blue-50 italic mb-6 leading-relaxed" data-id="element-276">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-277">
              <div className="w-10 h-10 rounded-full bg-navy-700 flex items-center justify-center text-gold-400 font-bold" data-id="element-278">
                {t.name.charAt(0)}
                {t.name.split(' ')[1]?.charAt(0)}
              </div>
              <div data-id="element-279">
                <p className="text-white font-bold" data-id="element-280">{t.name}</p>
                <p className="text-blue-200/60 text-sm" data-id="element-281">— {t.location}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}